/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const eventDetailPayoutListConfig = {
  title: 'Home Insurance Policy',
  subtitle: 'B2CGS50000123',
  buttons: [
    {
      key: 'approve',
      title: 'Approve',
      color: 'primary',
    },
    {
      key: 'reject',
      title: 'Reject',
      color: 'secondary',
    },
  ],
  timeLineButton: {
    key: 'timeLine',
    title: 'View Event Timeline',
    color: 'success',
  },
  listItems: [
    {
      key: 'stormName',
      title: 'Storm  Name',
      subTitle: '-',
      icon: 'https://s3.ap-south-1.amazonaws.com/io.klefki.parametro/storm.png',
    },
    {
      key: 'box',
      title: 'Box',
      subTitle: '-',
      icon: 'https://s3.ap-south-1.amazonaws.com/io.klefki.parametro/box_parametro.png',
    },
    {
      key: 'category',
      title: 'Storm Strength',
      subTitle: '-',
      icon: 'https://cdn-icons-png.flaticon.com/512/5455/5455381.png',
    },
    {
      key: 'country',
      title: 'Country',
      subTitle: '',
      icon: 'https://s3.ap-south-1.amazonaws.com/io.vlinder.icons/country-icon.png',
    },
    {
      key: 'date',
      title: 'Storm Occurrence Date',
      subTitle: '',
      icon: 'https://s3.ap-south-1.amazonaws.com/io.klefki.parametro/date_parametro.png',
    },
    {
      key: 'payout',
      title: 'Payout Estimate',
      subTitle: '-',
      icon: 'https://s3.ap-south-1.amazonaws.com/io.vlinder.icons/payment-icon.png',
    },
    {
      key: 'maxWindSpeed',
      title: 'Max. Wind Speed',
      subTitle: '',
      icon: 'https://s3.ap-south-1.amazonaws.com/io.klefki.parametro/wind.png',
    },
    {
      key: 'minWindSpeed',
      title: 'Min. Wind Speed',
      subTitle: '',
      icon: 'https://s3.ap-south-1.amazonaws.com/io.klefki.parametro/wind.png',
    },
  ],
  useOfProceedsDetail: {
    title: 'Use of Proceeds',
  },
  dateIcon: 'https://s3.ap-south-1.amazonaws.com/io.vlinder.tnt-demo/date.png',
  orgIcon:
    'https://s3.ap-south-1.amazonaws.com/io.vlinder.tnt-demo/organization.png',
  locationIcon:
    'https://s3.ap-south-1.amazonaws.com/io.vlinder.tnt-demo/location.png',
};
